<h2 mat-dialog-title i18n>Edit Workflow: {{ workflow.name }}</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <fieldset>
      <mat-form-field appearance="outline">
        <mat-label i18n>Workflow name</mat-label>
        <input matInput type="text"
               formControlName="name"
               placeholder="Name of your new workflow..."
               required>
        <mat-hint i18n>Workflow name is used for internal purposes only, it is not visible to the public.</mat-hint>
      </mat-form-field>
    </fieldset>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" i18n>Discard</button>
    <button mat-flat-button type="submit"
                            color="primary"
                            (click)="onSave()"
                            [disabled]="form.invalid"
                            i18n>Apply</button>
</mat-dialog-actions>
